export const MAX_UPLOAD_FILES_LIMIT = 5
export const FALLBACK_FILE_TYPE = 'FILE'
export const FILES_UPLOADED_CONFIRMATION_DURATION = 2000
